import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: '.5rem',
    borderBottom: `1px solid ${theme.palette.gray.efesBorder}`,
    alignItems: 'center',
    width: '100%',
    marginBottom: 14,
  },
  memberName: {
    fontSize: 14,
    wordBreak: 'break-word',
  },
  discountedPrice: {
    margin: '.5rem 0',
    height: '1.25rem',
  },
  addPromoCode: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: 14,
  },
  searchInputItem: {
    marginTop: '0.424rem',
  },
  input: {
    '& .MuiIconButton-root': {
      fontSize: 14,
      color: theme.palette.success.main,
    },
    '& .MuiIconButton-root:hover': {
      color: theme.palette.success.main,
      backgroundColor: 'inherit',
    },
  },
}));

export default useStyles;
